import type { ReactNode } from 'react'

import { OrgProfileSection } from '@/components/org-settings/org-profile-section.organism'
import { OrgSlugSection } from '@/components/org-settings/org-slug-section.organism'
import { Separator } from '@/components/ui/separator'

import { useGeneralSettings } from './use-general-settings.hook'

export const GeneralSettingsView: React.FC = (): ReactNode => {
  const settings = useGeneralSettings()

  const isNotAdmin = !settings.isAdmin

  return (
    <div className="general-settings-view space-y-8">
      <OrgProfileSection
        name={settings.name}
        imageUrl={settings.imageUrl}
        onNameChange={settings.handleNameChange}
        onLogoChange={settings.handleLogoChange}
        onLogoRemove={settings.handleLogoRemove}
        isLoading={settings.isNameLoading || settings.isLogoLoading}
        isDisabled={isNotAdmin}
      />
      <Separator />
      <OrgSlugSection
        slug={settings.slug}
        onSlugChange={settings.handleSlugChange}
        isLoading={settings.isSlugLoading}
        isDisabled={isNotAdmin}
      />
    </div>
  )
}

GeneralSettingsView.displayName = 'GeneralSettingsView'
